var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGsheets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1496 15.0798C14.1496 15.5918 13.7216 15.9998 13.2016 15.9998H3.29761C2.77361 15.9998 2.34961 15.5838 2.34961 15.0798V0.927812C2.34961 0.415812 2.77761 0.0078125 3.29761 0.0078125H9.66561L14.1496 4.47981V15.0798Z",
    fill: "#22A466"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1572 4.36816L14.1492 8.08016L14.1372 4.47616L10.1572 4.36816Z",
    fill: "#1A8E5A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1492 4.476H10.6052C10.0812 4.476 9.65723 4.06 9.65723 3.556V0L14.1492 4.476Z",
    fill: "#8ECEAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62964 12.3003V11.5003H10.5576V12.3003H8.62964ZM5.93364 11.5003H7.86164V12.3003H5.93364V11.5003ZM7.86964 10.9483H5.94164V10.0843H7.86964V10.9483ZM7.86964 8.60826V9.52826H5.94164V8.60826H7.86964ZM8.62964 10.0883H10.5576V10.9483H8.62964V10.0883ZM10.5576 9.52826H8.62964V8.60826H10.5576V9.52826ZM5.18164 7.86426V13.0483H11.3256V7.86426H5.18164Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGsheets);
export default __webpack_public_path__ + "static/media/gsheets.1e4d7cbd6fdfcfd85c373a3964484379.svg";
export { ForwardRef as ReactComponent };